import './App.css';
import { BrowserRouter, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import React, { Component, useEffect } from 'react';
import { getCookie, deleteCookie, setCookie, getCookieNoCrypto } from './Utils/CookieHelper';
import Service from './Networking/NetworkingUtils'
import Home from './Home/Home';
// import ChangePassword from './Home/ChangePassword';
import OpenProjectStore from './ProjectStore/OpenProjectStore';
import { increseCountTime } from './Helper/CommonThings';
import { AzureAD, AuthenticationState } from 'react-aad-msal';
import { authProvider, msClientId } from './Login/authProvider';
import { basicReduxStore } from './Login/reduxStore';
import LandingPage from './LandingPage/Landingpage';
import { Box, CircularProgress, Dialog, DialogContent, Typography } from '@mui/material';
import UserInvitation from './UserInvitation/UserInvitation';

var CryptoJS = require("crypto-js");

const LOGIN_ATTEMPT_KEY = 'bbverse_login_attempt_at';
const LOGIN_ATTEMPT_FAILURE_LOGGED_KEY = 'bbverse_login_attempt_failure_logged';
const INVITE_FLOW_STOP_KEY = 'bbverse_invite_flow_stop';
const INVITE_PROMPT_SHOWN_KEY = 'bbverse_invite_prompt_shown';
const PROJECT_STORE_ACCESS_KEY = 'bbverse_project_store_access';

var key = CryptoJS.enc.Utf8.parse('1234567890123456');

export function jwtEncryptKey() {
  return key
}

var fetchDone = {
  one: false,
  two: false
}

// const host_name = window.location.hostname

class App extends Component {
  constructor(props) {
    super(props)

    this.state = {
      go: false,
      checkInviteLoading: false,
      stopInviteFlow: sessionStorage.getItem(INVITE_FLOW_STOP_KEY) === '1'
    }

    this.tokenRequestInFlight = false;
    this.lastTokenRequestAccount = null;
    this.isComponentMounted = false;
  }

  componentDidMount() {
    this.isComponentMounted = true;
    if (getCookie("bb_metaverse_token")) {
      setInterval(() => {
        this.checkToken()
      }, 15000);
    }
    if (getCookie("bb_metaverse_access")) {
      this.getAccess()
    }
    if (!getCookie("bb_metaverse_token")) {
      deleteCookie("bb_metaverse_token");
      deleteCookie("bb_metaverse_user");
      deleteCookie("bb_metaverse_access");
    }
  }

  componentWillUnmount() {
    this.isComponentMounted = false;
  }

  setInviteLoading(isLoading, callback) {
    if (this.isComponentMounted) {
      this.setState({ checkInviteLoading: isLoading }, callback);
    } else if (typeof callback === 'function') {
      callback();
    }
  }

  setInviteFlowStop(shouldStop, callback) {
    if (shouldStop) {
      sessionStorage.setItem(INVITE_FLOW_STOP_KEY, '1');
    } else {
      sessionStorage.removeItem(INVITE_FLOW_STOP_KEY);
    }

    if (this.isComponentMounted) {
      this.setState({ stopInviteFlow: shouldStop }, callback);
    } else if (typeof callback === 'function') {
      callback();
    }
  }

  setGo() {
    setTimeout(() => { this.setState({ go: true }) }, 50);

  }

  getAccess() {
    var access = getCookie("bb_metaverse_access")
    this.getAccessImdt(getCookie("bb_metaverse_token"))
    setInterval(function () {
      if (increseCountTime() < 13) {
        Service.get(`/api/token/access/get_token_access_permissions/`, {
          headers: {
            Authorization: "Token " + getCookie("bb_metaverse_token"),
          },
        })
          .then(res => {
            if (res.data && res.data[0] && JSON.parse(access)) {
              if (JSON.parse(access).last_updated !== res.data[0].last_updated) {
                setCookie('bb_metaverse_access', JSON.stringify(res.data[0]), { secure: true, 'max-age': 604800, 'domain': window.location.host, 'samesite': 'None', 'path': '/', });
                // window.location.reload();
              }
              if (!getCookie("bb_metaverse_access")) {
                setCookie('bb_metaverse_access', JSON.stringify(res.data[0]), { secure: true, 'max-age': 604800, 'domain': window.location.host, 'samesite': 'strict', 'path': '/', });
                // window.location.reload();
              }
            } else if (res.data && res.data[0] && !getCookie("bb_metaverse_access")) {
              setCookie('bb_metaverse_access', JSON.stringify(res.data[0]), { secure: true, 'max-age': 604800, 'domain': window.location.host, 'samesite': 'strict', 'path': '/', });
              // window.location.reload();
            } else {
              setCookie('bb_metaverse_access', JSON.stringify({}), { secure: true, 'max-age': 604800, 'domain': window.location.host, 'samesite': 'strict', 'path': '/', });
            }
          })
          .catch(error => {
            setCookie('bb_metaverse_access', JSON.stringify({}), { secure: true, 'max-age': 604800, 'domain': window.location.host, 'samesite': 'strict', 'path': '/', });
          });
      }
    }, 1000 * 60 * 5);
  }

  getAccessImdt(token, with_refresh = false) {
    Service.get(`/api/token/access/get_token_access_permissions/`, {
      headers: {
        Authorization: "Token " + token,
      },
    })
      .then(res => {
        if (res.data && res.data[0]) {
          if (getCookie("bb_metaverse_access")) {
            if (JSON.parse(getCookie("bb_metaverse_access")).last_updated !== res.data[0].last_updated) {
              setCookie('bb_metaverse_access', JSON.stringify(res.data[0]), { secure: true, 'max-age': 604800, 'domain': window.location.host, 'samesite': 'strict', 'path': '/', });
            }
            fetchDone.one = true
          } else {
            setCookie('bb_metaverse_access', JSON.stringify(res.data[0]), { secure: true, 'max-age': 604800, 'domain': window.location.host, 'samesite': 'strict', 'path': '/', });
            fetchDone.one = true
          }
        } else {
          fetchDone.one = true
          setCookie('bb_metaverse_access', JSON.stringify({}), { secure: true, 'max-age': 604800, 'domain': window.location.host, 'samesite': 'strict', 'path': '/', });
        }
        if (with_refresh) {
          const attemptAgeMs = getLoginAttemptAgeMs();
          if (attemptAgeMs !== null) {
            console.log(`[AUTH] Authentication succeeded ${(attemptAgeMs / 1000).toFixed(1)}s after login invocation`);
            clearLoginAttempt();
            window.location.replace('/home');
          } else {
            window.location.replace('/home');
          }
        }
      })
      .catch(error => {
        setCookie('bb_metaverse_access', JSON.stringify({}), { secure: true, 'max-age': 604800, 'domain': window.location.host, 'samesite': 'strict', 'path': '/', });
        if (error && error.status === 401) {
          deleteCookie("bb_metaverse_token");
          deleteCookie("bb_metaverse_user");
          deleteCookie("bb_metaverse_access");
          window.location.reload()
        }
      });
  }

  checkToken() {
    Service.get(`/api/token/valid/check/`, {
      headers: {
        Authorization: "Token " + getCookie("bb_metaverse_token"),
      },
    })
      .then(res => {
        if (!this.state.go) {
          this.setGo();
        }
      })
      .catch(error => {
        if (error && error.status === 401) {
          deleteCookie("bb_metaverse_token");
          deleteCookie("bb_metaverse_user");
          deleteCookie("bb_metaverse_access");
          window.location.reload();
        }
      });
  }

  userPendingRequestsExists() {
    if (this.state.stopInviteFlow) {
      return;
    }

    this.setInviteLoading(true);
    Service.get(`/api/app/user/invite/get_user_pending_invitation_lists/`, {
      headers: {
        Authorization: getCookieNoCrypto('msal.' + msClientId + '.idtoken'),
      }
    })
      .then(res => {
        if (res.data.length > 0) {
          this.setInviteLoading(false, () => {
            this.setInviteFlowStop(true);
            window.location.href = '/user/invite'
          });
        } else {
          this.setInviteLoading(false, () => {
            this.setInviteFlowStop(true, () => {
              sessionStorage.setItem(PROJECT_STORE_ACCESS_KEY, '1');
              // alert("You don't have any pending requests in BBverse.")
              window.location.replace('/store')
            });
          });
        }
      })
      .catch(error => {
        this.setInviteLoading(false, () => {
          console.log(error)
        });

      })
  }

  showNotAddedAlertAndCheckInvites() {
    if (
      this.state.stopInviteFlow ||
      sessionStorage.getItem(INVITE_FLOW_STOP_KEY) === '1' ||
      sessionStorage.getItem(INVITE_PROMPT_SHOWN_KEY) === '1'
    ) {
      return;
    }

    sessionStorage.setItem(INVITE_PROMPT_SHOWN_KEY, '1');
    //  const shouldCheckInvites = window.confirm("We haven't added you to BBVerse. Check pending invites?");
    this.userPendingRequestsExists();
  }

  

  getTokenFromDj(data) {
    if (!data || !data.jwtIdToken) {
      return;
    }

    if (window.location.pathname === '/user/invite') {
      return;
    }

    if (this.state.stopInviteFlow) {
      return;
    }

    const accountIdentifier = data?.account?.userName || data?.account?.name || data?.userName || 'unknown';
    if (this.tokenRequestInFlight || this.lastTokenRequestAccount === accountIdentifier) {
      return;
    }

    this.tokenRequestInFlight = true;
    this.lastTokenRequestAccount = accountIdentifier;

    Service.patch(`/api/generate/token/token_update/`, {
      data: {
        id_token: encryptJWT("D1R1P" + data.jwtIdToken + "D1R1P", key),
      }
    })
      .then(res => {
        if (res.data && res.data.token && res.data.user) {
          setCookie('bb_metaverse_token', res.data.token, { secure: true, 'max-age': 604800, 'domain': window.location.host, 'samesite': 'None', 'path': '/', },);
          setCookie('bb_metaverse_user', JSON.stringify(res.data.user), { secure: true, 'max-age': 604800, 'domain': window.location.host, 'samesite': 'None', 'path': '/', },);
          this.getAccessImdt(res.data.token, true)
        } else {
          this.lastTokenRequestAccount = null;
          // this.openProjectStoreForNoAccess();
          this.showNotAddedAlertAndCheckInvites();
        }
      })
      .catch(error => {
        this.lastTokenRequestAccount = null;
        if (error.status === 406) {
          // this.openProjectStoreForNoAccess();
          this.showNotAddedAlertAndCheckInvites();
        }
        console.log(error);
      })
      .finally(() => {
        this.tokenRequestInFlight = false;
      });
  }

  render() {
    return (
      <>
        <Dialog
          open={this.state.checkInviteLoading}
          aria-labelledby="checking-invites-dialog-title"
          disableEscapeKeyDown
        >
          <DialogContent
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '12px',
              padding: '24px 32px'
            }}
          >
            <CircularProgress />
            <Typography id="checking-invites-dialog-title" variant="body1">
              Checking for Invites
            </Typography>
          </DialogContent>
        </Dialog>
        <BrowserRouter>
          <AzureAD provider={authProvider} reduxStore={basicReduxStore} forceLogin={false} >
            {
              ({ login, logout, authenticationState, error, accountInfo }) => {
                const trackedLogin = () => {
                  markLoginAttempt();
                  console.log('[AUTH] Login function invoked');
                  try {
                    const loginResult = login();
                    if (loginResult && typeof loginResult.then === 'function') {
                      return loginResult
                        .then((result) => {
                          console.log('[AUTH] Login function returned successfully');
                          return result;
                        })
                        .catch((loginError) => {
                          console.error('[AUTH] Login function rejected', loginError);
                          throw loginError;
                        });
                    }

                    console.log('[AUTH] Login function returned successfully');
                    return loginResult;
                  } catch (loginError) {
                    console.error('[AUTH] Login function threw', loginError);
                    throw loginError;
                  }
                };

                switch (authenticationState) {
                  case AuthenticationState.Authenticated:
                    {
                      const isInvitePath = window.location.pathname === '/user/invite';
                      const isLandingPath = window.location.pathname === '/';
                      const isStorePath = window.location.pathname === '/store';
                      const hasProjectStoreAccess = sessionStorage.getItem(PROJECT_STORE_ACCESS_KEY) === '1';
                      const hasBbverseToken = !!getCookie("bb_metaverse_token");
                      if (!hasBbverseToken && !isStorePath && !hasProjectStoreAccess) {
                        if (!this.state.stopInviteFlow) {
                          console.log("Getting token from DJ")
                          this.getTokenFromDj(accountInfo)
                        }
                      } else if (hasBbverseToken) {
                        this.setGo()
                      }
                      return (
                        <>
                          {((this.state.go && hasBbverseToken) || isInvitePath || isStorePath || (isLandingPath && hasProjectStoreAccess)) ? (
                            <AppRoute loginFunc={trackedLogin} isMsAuthenticated />
                          ) : (
                            <p>Authenticating...</p>
                          )}
                        </>
                      );
                    }
                  case AuthenticationState.Unauthenticated:
                    {
                      this.tokenRequestInFlight = false;
                      this.lastTokenRequestAccount = null;
                      console.log('[AUTH] User is unauthenticated');
                      const attemptAgeMs = getLoginAttemptAgeMs();
                      const failureAlreadyLogged = !!sessionStorage.getItem(LOGIN_ATTEMPT_FAILURE_LOGGED_KEY);
                      if (attemptAgeMs !== null && attemptAgeMs > 60000 && !failureAlreadyLogged) {
                        console.warn('[AUTH] Login attempt has not reached authenticated state after 60s', error);
                        sessionStorage.setItem(LOGIN_ATTEMPT_FAILURE_LOGGED_KEY, '1');
                      }
                    }
                    console.log(error)
                    deleteCookie("bb_metaverse_token");
                    deleteCookie("bb_metaverse_user");
                    deleteCookie("bb_metaverse_access");
                    return (<AppRoute loginFunc={trackedLogin} isMsAuthenticated={false} />);
                  case AuthenticationState.InProgress:
                    return (<p>Authenticating...</p>);
                  default:
                    return (<p>Authenticating...</p>);
                }
              }
            }
          </AzureAD>

        </BrowserRouter>
      </>
    )
  }
}
export default App



function ProtectedRoute({ children }) {
  const isAuthenticated = !!getCookie("bb_metaverse_token");
  // If not authenticated, always redirect to /landing (not /)
  return isAuthenticated ? children : <Navigate to="/" replace />;
}

function StoreRoute({ children, isMsAuthenticated }) {
  const isAuthenticated = isMsAuthenticated || !!getCookie("bb_metaverse_token");
  return isAuthenticated ? children : <Navigate to="/" replace />;
}

function AppRoute({ loginFunc, isMsAuthenticated }) {
  const location = useLocation();
  useEffect(() => {
    sessionStorage.setItem("previousPath", location.pathname);
  }, [location.pathname]);
  return (
    <Routes>
      <Route path="/" element={<LandingPage onLogin={loginFunc} />} />
      <Route path="/home" element={
        <ProtectedRoute>
          <Home />
        </ProtectedRoute>
      } />
      <Route path="/store" element={
        <StoreRoute isMsAuthenticated={isMsAuthenticated}>
          <Box margin={2}>
          <OpenProjectStore isMsalAuthenticated={false} />
          </Box>
        </StoreRoute>
      } />
      <Route path='/user/invite' element={
        <UserInvitation />
      } />
    </Routes>
  );
}

export function encryptJWT(msgString, key) {
  var iv = CryptoJS.lib.WordArray.random(16);
  var encrypted = CryptoJS.AES.encrypt(msgString, key, {
    iv: iv
  });
  return iv.concat(encrypted.ciphertext).toString(CryptoJS.enc.Base64);
}

// function check_excluded_domains() {
//   for (var i = 0; i < list_of_excluded_domains.length; i++) {
//     if (window.location.hostname.includes(list_of_excluded_domains[i])) {
//       return true
//     }
//   }
// }

function markLoginAttempt() {
  const now = Date.now().toString();
  sessionStorage.setItem(LOGIN_ATTEMPT_KEY, now);
  sessionStorage.removeItem(LOGIN_ATTEMPT_FAILURE_LOGGED_KEY);
}

function clearLoginAttempt() {
  sessionStorage.removeItem(LOGIN_ATTEMPT_KEY);
  sessionStorage.removeItem(LOGIN_ATTEMPT_FAILURE_LOGGED_KEY);
}

function getLoginAttemptAgeMs() {
  const startedAt = sessionStorage.getItem(LOGIN_ATTEMPT_KEY);
  if (!startedAt) {
    return null;
  }

  const parsed = Number(startedAt);
  if (Number.isNaN(parsed)) {
    clearLoginAttempt();
    return null;
  }

  return Date.now() - parsed;
}